import { Injectable } from '@angular/core';
import { SlokaTypeLogicService } from './sloka-type.service';
import { SlokaLogicService } from './sloka.service';
import { SlokaTypeModel, SlokaBackendModel, BookGetModel, EventGetModel, BlogPostGetModel } from '../interfaces/interfaces';
import { PassDataService } from '../services/pass-data.service';
import { Observable, combineLatest } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BookLogicService } from './book.service';
import { EventLogicService } from './event-service';
import { BlogPostLogicService } from './blog-post.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardLogicService {
  constructor(
    private slokaTypeLogicService: SlokaTypeLogicService,
    private slokaLogicService: SlokaLogicService,
    private passDataService: PassDataService,
    private bookLogicService: BookLogicService,
    private eventLogicService: EventLogicService,
    private blogPostLogicService: BlogPostLogicService,
  ) {}

  getAllSlokaTypesAndSlokas() {
    let allBooks$ = this.bookLogicService.getAllBooksLogic();
    let allSlokaTypes$ = this.slokaTypeLogicService.getAllSlokaTypesLogic();
    let allSlokas$ = this.slokaLogicService.getAllSlokasLogic();
    let allEvents$ = this.eventLogicService.getAllEventsLogic();
    let allBlogPosts$ = this.blogPostLogicService.getAllBlogPostsLogic();

    return combineLatest([allSlokaTypes$, allSlokas$, allBooks$, allEvents$, allBlogPosts$]).pipe(
      switchMap((v) => {

        let allSlokaTypes: SlokaTypeModel[] = v[0];
        let allSlokas: SlokaBackendModel[] = v[1];
        let allBooks: BookGetModel[] = v[2];
        let allEvents: EventGetModel[] = v[3];
        let allPosts: BlogPostGetModel[] = v[4];

        this.passDataService.setAllSlokas(allSlokas);
        this.passDataService.setAllBooks(allBooks);
        this.passDataService.setAllEvents(allEvents);
        this.passDataService.setAllBlogPosts(allPosts);

        let finalSlokaTypes = allSlokaTypes.filter((st) =>
          allSlokas.every((s) =>
            st.id == s.slokaTypeId ? (st.totalSlokas += 1) : st
          )
        );

        this.passDataService.setAllSlokaTypes(finalSlokaTypes);

        return [finalSlokaTypes];
      })
    );
  }
}
